import { Card } from "@/components/Shared/Card";
import Footer from "@/components/Shared/Footer";
import { RegisterForm } from "@/components/Auth/RegisterForm";
import { Content } from "@/components/ui/ContentArea";

export function RegisterPage() {
	return (
		<Content>
			<div className="flex flex-col items-center justify-center flex-1">
				<h1 className="grid grid-cols-2 gap-10">
					<img src="/img/Logo_Cluster_Completo.svg" className="h-30"></img>
					<img src="/img/Logo_Wunder_Completo.svg" className="h-30"></img>
				</h1>

				<Card style={{ minWidth: "450px", margin: "16pt" }}>
					<RegisterForm />
				</Card>
			</div>
			<Footer />
		</Content>
	);
}
